<!-- Conteneur avec dimensions fixes pour éviter les layout shifts -->
<div class="newsletter-area newsletter-fix-height">
  <div class="container">
    <div class="newsletter-inner-box">
      <div class="row align-items-center g-0"> <!-- g-0 pour éviter les gutters variables -->
        <div class="col-lg-6 col-md-12">
          <div class="newsletter-content">
            <!-- Conteneur avec hauteur minimale pour stabiliser le texte -->
            <div class="content-wrapper" [style.min-height.px]="100">
              <h3>Newsletter<i class="ri-notification-2-fill"></i></h3>
              <p>Abonnez-vous gratuitement pour ne pas rater nos prochaines publications</p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <!-- Form avec hauteur fixe pour éviter les shifts -->
          <div class="form-wrapper" [style.min-height.px]="80">
            <form class="newsletter-form" [formGroup]="subscribeForm" (ngSubmit)="onSubmit()">
              <div class="input-group-wrapper">
                <input 
                  type="email" 
                  class="input-newsletter" 
                  placeholder="Votre adresse email" 
                  formControlName="email"
                  [style.height.px]="60" />
                <button 
                  type="submit" 
                  [disabled]="!subscribeForm.valid"
                  [style.height.px]="52">
                  S'abonner
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>